<template>
    <div class="home">
        <h1>{{city}}</h1>
        <router-link style="width:100px;height:40px;background:yellow" tag="button" to="/cityList"></router-link>
        <p>{{$store.state.counter}}</p>
        <button @click="increment(5)">加5</button>
        <!-- <h1>{{$store.getter.sqrtCounter}}</h1> -->
        <!-- <p @click="addFive">加5</p> -->
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    computed:{
        city:function(){
            return this.$store.getters.getCityFn;
        }
    },
    created() {
        this.changeData()
    },
    methods: {
        increment(num){
            this.$store.commit('add',num)
        },
        changeData(){
            let vm =  {}
            let data = {
                name:'yuan',
                age:'27'
            }
            for (let key in data){
                if(data.hasOwnProperty(key)){
                    Object.defineProperty(vm,key,{
                        get:function(){
                            return data[key]
                        },
                        set:function(newValue){
                            data[key]=newValue
                        }
                    })
                }
            }
        }
    },
    
}
</script>



// WEBPACK FOOTER //
// src/pages/city/city.vue